"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixEllipsis = fixEllipsis;
const tex_syntax_1 = require("./tex-syntax");
function fixEllipsis(tex) {
    return tex.replace(new RegExp(`\\\\hphantom${(0, tex_syntax_1.arg)(4)}|\\\\bond${(0, tex_syntax_1.arg)(0)}|\\.\\.\\.`, "g"), (token) => {
        if (token === "...") {
            return "\\unicode{0x2026}";
        }
        return token;
    });
}
